import { useEffect } from 'react'

import expander from 'views/assets/scripts/expander'
import floatingLabel from 'views/assets/scripts/floatingLabel'
import NowShippingModalCartContent from 'views/components/organisms/NowShippingModal/NowShippingModalContent/cartModal'

const NowShippingModalCartContainer = () => {
  useEffect(() => {
    expander()
    floatingLabel()
  }, [])

  return <NowShippingModalCartContent />
}

export default NowShippingModalCartContainer
